export default __webpack_public_path__ + "static/MediaContentFive-02485fbb26b6ac65e2bef44e47236ef0.webp";